<!-- 意见反馈 -->
<template>
  <div class="opinion">
    <v-head></v-head>
    <div class="container" style="min-width:1200px;">
      <!-- banner -->
      <div class="opinion-banner">
        <div class="opinion-banner-img" :style="'background-image:url('+ img +')'"></div>
        <!-- <img :src="img" alt width="100%" height="100%" /> -->
        <div class="banner-message">
          <div class="banner-message-title">意见与建议</div>
          <div class="banner-message-main">我们致力于给您提供个性化的进校园商业服务，有任何问题或者建议请与我们联系！</div>
        </div>
      </div>
      <!-- form 表单反馈信息 -->
      <div class="opinion-form">
        <el-form
          :model="form"
          status-icon
          ref="form"
          :rules="rules"
          label-width="120px"
          class="form-boxs"
        >
          <el-form-item label="反馈标题" prop="fk_title">
            <el-input v-model.trim="form.fk_title" maxlength="30" placeholder="请输入您想反馈的问题标题"></el-input>
            <div class="input-number">
              <span>{{ form.fk_title.length }}</span>/30
            </div>
          </el-form-item>
          <el-form-item label="反馈内容" prop="fk_content">
            <el-input
              type="textarea"
              :rows="5"
              :autosize="{minRows: 5, maxRows: 10}"
              :maxlength="500"
              v-model.trim="form.fk_content"
              placeholder="请输入您想反馈的内容"
            ></el-input>
            <div class="input-number">
              <span>{{ form.fk_content.length }}</span>/500
            </div>
          </el-form-item>
          <el-form-item label="您的姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
            <div class="input-number"></div>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
            <div class="input-number"></div>
          </el-form-item>
          <el-form-item label="验证码" prop="code" class="item-code">
            <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
            <div class="item-codeImg">
              <img
                :src="imgCodeUrl"
                alt="验证码"
                width="100%"
                @click="getNewCodeImgKey()"
                height="100%"
              />
            </div>
            <div class="input-number"></div>
          </el-form-item>
          <el-form-item style="text-align:center" class="submit-button">
            <el-button
              size="small"
              :type="formType"
              @click="submitForm('form')"
              :disabled="formStatus"
            >{{ formEnter }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- footer -->
      <v-footer class="body-bottom-absolute"></v-footer>
    </div>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import bg from '@/assets/img/bg-zz.png'
import {
  Form,
  FormItem,
  Button,
  Input
} from 'element-ui'
export default {
  data () {
    var validatePhone = (rule, value, callback) => {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) && !/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      img: bg, // 临时图片
      formEnter: '提交反馈',
      formType: 'primary',
      formStatus: false,
      form: {
        fk_title: '',
        fk_content: '',
        name: '',
        phone: '',
        code: ''
      },
      randomKey: '',
      imgCodeUrl: this.commonapi + '/captcha?uuid=' + this.randomKey,
      rules: {
        fk_title: [
          { required: true, message: '请输入反馈标题', trigger: 'blur' },
          { max: 30, message: '长度在 30 个字符以内', trigger: 'blur' }
        ],
        fk_content: [
          { required: true, message: '请输入反馈内容', trigger: 'blur' },
          { max: 500, message: '长度在 500 个字符以内', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { max: 30, message: '长度在 30 个字符以内', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    'v-head': vHead,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-button': Button,
    'el-input': Input,
    'v-footer': vFooter
  },
  mounted () {
    this.getNewCodeImgKey()
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        let params = {
          title: this.form.fk_title,
          content: this.form.fk_content,
          username: this.form.name,
          phone: this.form.phone,
          uuid: this.randomKey,
          code: this.form.code
        }
        if (valid) {
          this.$http({
            method: 'POST',
            url: '/feedback/add',
            params: params
          }).then(res => {
            if (res.code === 100) {
              this.$message.success('提交成功')
              Object.assign(this.$data.form, this.$options.data().form)
              this.formEnter = '提交成功'
              this.formType = 'success'
              this.formStatus = true
            } else {
              this.$message.error(res.msg)
              this.getNewCodeImgKey()
              return false
            }
          }).catch(error => {
            console.log(error)
            this.getNewCodeImgKey()
            return false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 生成图片验证码Key
    getNewCodeImgKey () {
      // this.randomKey = Math.ceil(Math.random() * 1000) // 生成一个随机key（防止缓存)
      this.randomKey = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      this.imgCodeUrl = this.commonapi + '/captcha?uuid=' + this.randomKey
    }
  }
}
</script>
<style src='./opinion_native.scss' lang="scss"></style>
<style lang="scss" scoped>
.opinion {
  width: 100%;
  height: 100%;
  overflow: hidden;
  // banner
  .opinion-banner {
    width: 100%;
    height: 450px;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    .opinion-banner-img {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .banner-message {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding-top: 60px;
      box-sizing: border-box;
      .banner-message-title {
        font-size: 36px;
        color: #ffffff;
        padding: 18px 0;
      }
      .banner-message-main {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        padding: 15px 0;
        letter-spacing: 1px;
      }
    }
  }
  // form
  .opinion-form {
    width: 50%;
    margin: 50px auto;
    .form-boxs {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/opinion/opinion.vue